import './_empty-cart-collection-cards.scss';

export default () => {};
